
interface iArrayHandler {page_index:number,step:number,array:any[]}
export function arrayHandler ({page_index,step,array}:iArrayHandler){

    return array.slice(0+(step *page_index),(step-1)+(step*page_index))
}

export function arraySlicer (arr:any[]):any[] {

     if (arr.length<5) return arr

     return [arr.slice(0,5),arraySlicer(arr.slice(5,-1))]


}